<template>
  <v-row justify="center">
    <v-dialog v-model="show" width="500px">
      <v-card>
        <v-card-title style="justify-content: center">{{ $t('product.custom.title') }}</v-card-title>
        <v-card-text v-if="customs.length !== 0">
          <v-list two-line>
            <v-list-item v-for="custom in customs" :key="custom._id" justify="center">
              <v-list-item-content>
                <div class="d-flex flex-wrap">
                  <span class="font-weight-bold">{{ custom.name }} :</span>
                  <span class="pl-1 text--secondary text-break">{{ noWrapValue(custom.value) }}</span>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-text v-else class="text-center">
          {{ $t('product.custom.noCustoms') }}
        </v-card-text>
        <v-card-actions class="pa-0">
          <v-btn color="secondary" tile block @click="close">{{ $t('subOrder.return') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name: 'ItemCustomFields',
    props: {
      customs: {
        type: Array,
        required: true,
      },
      value: {
        required: true,
      },
    },
    computed: {
      show: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
    },
    methods: {
      close: function () {
        this.$emit('close')
      },
      noWrapValue(val) {
        return val.replace(/ /g, '\u00A0') // replace spaces with non-breaking spaces
      },
    },
  }
</script>

<style scoped>
  .text-break {
    white-space: normal;
    overflow-wrap: break-word;
    word-break: break-word;
  }
</style>
